import type { ComponentProps } from 'react';
import React, { memo } from 'react';
import styled from '@emotion/styled';
import { alignItems, flex, width } from 'styled-system';

import EnergyLabel from '../EnergyLabel';
import { Flex } from '../Flex';

interface EnergyLabelListProps {
  urls: string[];
}

const UnstyledContainer = styled(Flex)``;

const Container = (props: ComponentProps<typeof UnstyledContainer>) => (
  <UnstyledContainer
    as="ul"
    m="sp_0"
    p="sp_0"
    flexDirection={['column', null, null, 'row']}
    flexWrap="wrap"
    {...props}
  />
);

const UnstyledItem = styled(EnergyLabel)<any>`
  ${width};
  ${flex};
  ${alignItems};
`;

const Item = (props: ComponentProps<typeof UnstyledItem>) => (
  <UnstyledItem as="li" alignItems="flex-start" {...props} />
);

const EnergyLabelList = ({ urls }: EnergyLabelListProps) => {
  const isSingleItem = urls.length === 1;
  const styleProps = {
    width: [null, null, null, isSingleItem ? 1 : 1 / 5],
    ...(!isSingleItem && { flex: '0 50%' }),
  };

  return (
    <Container>
      {urls.map(url => (
        <Item key={url} url={url} {...styleProps} />
      ))}
    </Container>
  );
};

export default memo(EnergyLabelList);
